
// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   ToggleButton,
//   ToggleButtonGroup,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableRow,
// } from '@mui/material';

// const expectedSchema = {
//   host: 'string',
//   port: 'number',
//   n_logs: 'number',
//   root_ca: 'string',
//   tel_period: 'number',
//   always_on_inet: 'boolean',
// };

// const labelMap = {
//   host: 'Host',
//   port: 'Port',
//   n_logs: 'Number of Logs',
//   root_ca: 'Root CA (.crt/.pem)',
//   tel_period: 'Telemetry Period',
//   always_on_inet: 'Always On Internet',
// };

// const defaultJson = {
//   host: '',
//   port: 0,
//   n_logs: 5000,
//   root_ca: '',
//   tel_period: 180,
//   always_on_inet: true,
// };

// function NewConfigPage() {
//   const [configName, setConfigName] = useState('');
//   const [jsonMode, setJsonMode] = useState('manual');
//   const [jsonInput, setJsonInput] = useState('');
//   const [jsonError, setJsonError] = useState('');
//   const [jsonData, setJsonData] = useState(defaultJson);
//   const [serverResponse, setServerResponse] = useState({ error: '', message: '' });

//   useEffect(() => {
//     if (jsonMode === 'manual') {
//       setJsonData(defaultJson);
//     }
//   }, [jsonMode]);

//   const handleConfigNameChange = (e) => {
//     const value = e.target.value;
//     const regex = /^[A-Z0-9@]+$/i;
//     if (value === '' || regex.test(value)) {
//       setConfigName(value);
//     }
//   };

//   const validateJsonSchema = (data) => {
//     return (
//       typeof data === 'object' &&
//       data !== null &&
//       Object.entries(expectedSchema).every(([key, type]) => {
//         if (!(key in data)) return false;
//         return typeof data[key] === type;
//       })
//     );
//   };

//   const handleJsonChange = (e) => {
//     const value = e.target.value;
//     setJsonInput(value);
//     try {
//       const parsed = JSON.parse(value);
//       if (!validateJsonSchema(parsed)) throw new Error('Invalid schema');
//       setJsonData(parsed);
//       setJsonError('');
//     } catch {
//       setJsonError('Invalid JSON or schema mismatch');
//       setJsonData(null);
//     }
//   };

//   const handleFileUpload = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const reader = new FileReader();
//     reader.onload = (event) => {
//       const text = event.target.result;
//       setJsonInput(text);
//       try {
//         const parsed = JSON.parse(text);
//         if (!validateJsonSchema(parsed)) throw new Error('Invalid schema');
//         setJsonData(parsed);
//         setJsonError('');
//       } catch {
//         setJsonError('Invalid JSON or schema mismatch');
//         setJsonData(null);
//       }
//     };
//     reader.readAsText(file);
//   };

//   const handleRootCAUpload = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onload = (event) => {
//       const certContent = event.target.result;
//       setJsonData((prev) => ({
//         ...prev,
//         root_ca: certContent,
//       }));
//     };
//     reader.readAsText(file);
//   };

//   const handleSave = () => {
//     if (!configName || !jsonData || !validateJsonSchema(jsonData)) return;

//     fetch('http://localhost:5000/api/save-config', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ name: configName, config: jsonData }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.error) {
//           setServerResponse({ error: data.error, message: '' });
//         } else {
//           setServerResponse({ error: '', message: 'Configuration saved successfully.' });
//         }
//       })
//       .catch(() => {
//         setServerResponse({ error: 'Failed to save configuration.', message: '' });
//       });
//   };

//   return (
//     <Box sx={{ maxWidth: 800, mx: 'auto', mt: 5, px: 3, py: 4 }}>
//       <Typography variant="h4" fontWeight="bold" gutterBottom>
//         Add New Configuration
//       </Typography>

//       <TextField
//         fullWidth
//         label="Config Name (A-Z, 0-9, @)"
//         value={configName}
//         onChange={handleConfigNameChange}
//         margin="normal"
//       />

//       <ToggleButtonGroup
//         color="primary"
//         value={jsonMode}
//         exclusive
//         onChange={(e, newValue) => {
//           if (newValue) {
//             setJsonMode(newValue);
//             setJsonError('');
//             setJsonInput('');
//           }
//         }}
//         sx={{ mt: 2, mb: 3 }}
//       >
//         <ToggleButton value="manual">Manual Entry</ToggleButton>
//         <ToggleButton value="upload">Upload JSON</ToggleButton>
//       </ToggleButtonGroup>

//       {jsonMode === 'manual' ? (
//         <Paper variant="outlined" sx={{ p: 2 }}>
//           <Table>
//             <TableBody>
//               {Object.entries(expectedSchema).map(([key, type]) => (
//                 <TableRow key={key}>
//                   <TableCell sx={{ width: 220 }}>
//                     <Typography>{labelMap[key]}</Typography>
//                   </TableCell>
//                   <TableCell>
//                     {key === 'root_ca' ? (
//                       <>
//                         <Button variant="outlined" component="label" size="small" sx={{ mb: 1 }}>
//                           Upload .crt/.pem
//                           <input
//                             type="file"
//                             accept=".crt,.pem"
//                             hidden
//                             onChange={handleRootCAUpload}
//                           />
//                         </Button>
//                         <TextField
//                           fullWidth
//                           multiline
//                           rows={4}
//                           value={jsonData?.root_ca}
//                           placeholder="Root CA content"
//                           onChange={(e) =>
//                             setJsonData((prev) => ({ ...prev, root_ca: e.target.value }))
//                           }
//                         />
//                       </>
//                     ) : type === 'boolean' ? (
//                       <ToggleButtonGroup
//                         value={
//                           jsonData?.[key] === true
//                             ? 'true'
//                             : jsonData?.[key] === false
//                             ? 'false'
//                             : ''
//                         }
//                         exclusive
//                         onChange={(e, val) => {
//                           if (val !== null) {
//                             setJsonData((prev) => ({
//                               ...prev,
//                               [key]: val === 'true',
//                             }));
//                           }
//                         }}
//                         size="small"
//                       >
//                         <ToggleButton value="true">True</ToggleButton>
//                         <ToggleButton value="false">False</ToggleButton>
//                       </ToggleButtonGroup>
//                     ) : (
//                       <TextField
//                         type={type === 'number' ? 'number' : 'text'}
//                         fullWidth
//                         value={jsonData?.[key] ?? ''}
//                         onChange={(e) => {
//                           const inputVal = e.target.value;
//                           const val = type === 'number' ? Number(inputVal) : inputVal;
//                           setJsonData((prev) => ({
//                             ...prev,
//                             [key]: val,
//                           }));
//                         }}
//                       />
//                     )}
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </Paper>
//       ) : (
//         <Box>
//           <Button variant="contained" component="label" sx={{ mb: 2 }}>
//             Upload JSON File
//             <input type="file" accept=".json" hidden onChange={handleFileUpload} />
//           </Button>

//           <TextField
//             label="JSON Preview"
//             multiline
//             rows={8}
//             fullWidth
//             value={jsonInput}
//             onChange={handleJsonChange}
//             error={Boolean(jsonError)}
//             helperText={jsonError || ''}
//           />
//         </Box>
//       )}

//       {jsonData && configName && validateJsonSchema(jsonData) && (
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={handleSave}
//           sx={{ mt: 4, display: 'block', mx: 'auto' }}
//         >
//           Save Configuration
//         </Button>
//       )}

//       {serverResponse.error ? (
//         <Typography
//           color="error"
//           sx={{ mt: 3, textAlign: 'center', fontSize: '1.1rem', fontWeight: 'bold' }}
//         >
//           {serverResponse.error}
//         </Typography>
//       ) : (
//         serverResponse.message && (
//           <Typography
//             color="success.main"
//             sx={{ mt: 3, textAlign: 'center', fontSize: '1.1rem', fontWeight: 'bold' }}
//           >
//             {serverResponse.message}
//           </Typography>
//         )
//       )}
//     </Box>
//   );
// }

// export default NewConfigPage;
import React, { useState, useEffect } from 'react';
import axios from './AxiosInstance';
import {
  Box,
  Button,
  TextField,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';

const expectedSchema = {
  host: 'string',
  port: 'number',
  n_logs: 'number',
  root_ca: 'string',
  tel_period: 'number',
  always_on_inet: 'boolean',
};

const labelMap = {
  host: 'Host',
  port: 'Port',
  n_logs: 'Number of Logs',
  root_ca: 'Root CA (.crt/.pem)',
  tel_period: 'Telemetry Period',
  always_on_inet: 'Always On Internet',
};

const defaultJson = {
  host: '',
  port: 0,
  n_logs: 5000,
  root_ca: '',
  tel_period: 180,
  always_on_inet: true,
};

function NewConfigPage() {
  const [configName, setConfigName] = useState('');
  const [jsonMode, setJsonMode] = useState('manual');
  const [jsonInput, setJsonInput] = useState('');
  const [jsonError, setJsonError] = useState('');
  const [jsonData, setJsonData] = useState(defaultJson);
  const [serverResponse, setServerResponse] = useState({ error: '', message: '' });

  useEffect(() => {
    if (jsonMode === 'manual') {
      setJsonData(defaultJson);
    }
  }, [jsonMode]);

  // ✅ Updated to allow only uppercase A-Z, 0-9, and @
  const handleConfigNameChange = (e) => {
    const value = e.target.value.toUpperCase(); // Convert to uppercase
    const regex = /^[A-Z0-9@]*$/; // Allow only A-Z, 0-9, @

    if (value === '' || regex.test(value)) {
      setConfigName(value);
    }
  };

  const validateJsonSchema = (data) => {
    return (
      typeof data === 'object' &&
      data !== null &&
      Object.entries(expectedSchema).every(([key, type]) => {
        if (!(key in data)) return false;
        return typeof data[key] === type;
      })
    );
  };

  const handleJsonChange = (e) => {
    const value = e.target.value;
    setJsonInput(value);
    try {
      const parsed = JSON.parse(value);
      if (!validateJsonSchema(parsed)) throw new Error('Invalid schema');
      setJsonData(parsed);
      setJsonError('');
    } catch {
      setJsonError('Invalid JSON or schema mismatch');
      setJsonData(null);
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target.result;
      setJsonInput(text);
      try {
        const parsed = JSON.parse(text);
        if (!validateJsonSchema(parsed)) throw new Error('Invalid schema');
        setJsonData(parsed);
        setJsonError('');
      } catch {
        setJsonError('Invalid JSON or schema mismatch');
        setJsonData(null);
      }
    };
    reader.readAsText(file);
  };

  const handleRootCAUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      const certContent = event.target.result;
      setJsonData((prev) => ({
        ...prev,
        root_ca: certContent,
      }));
    };
    reader.readAsText(file);
  };

  const handleSave = async () => {
    if (!configName || !jsonData || !validateJsonSchema(jsonData)) return;

    try {
      const res = await axios.post('/api/save-config', {
        name: configName,
        config: jsonData,
      });

      if (res.data?.error) {
        setServerResponse({ error: res.data.error, message: '' });
      } else {
        setServerResponse({ error: '', message: 'Configuration saved successfully.' });
      }
    } catch (err) {
      console.error(err);
      setServerResponse({
        error: err.response?.data?.error || 'Failed to save configuration.',
        message: '',
      });
    }
  };

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', mt: 5, px: 3, py: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Add New Configuration
      </Typography>

      <TextField
        fullWidth
        label="Config Name (A-Z, 0-9, @)"
        value={configName}
        onChange={handleConfigNameChange}
        margin="normal"
      />

      <ToggleButtonGroup
        color="primary"
        value={jsonMode}
        exclusive
        onChange={(e, newValue) => {
          if (newValue) {
            setJsonMode(newValue);
            setJsonError('');
            setJsonInput('');
          }
        }}
        sx={{ mt: 2, mb: 3 }}
      >
        <ToggleButton value="manual">Manual Entry</ToggleButton>
        <ToggleButton value="upload">Upload JSON</ToggleButton>
      </ToggleButtonGroup>

      {jsonMode === 'manual' ? (
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Table>
            <TableBody>
              {Object.entries(expectedSchema).map(([key, type]) => (
                <TableRow key={key}>
                  <TableCell sx={{ width: 220 }}>
                    <Typography>{labelMap[key]}</Typography>
                  </TableCell>
                  <TableCell>
                    {key === 'root_ca' ? (
                      <>
                        <Button variant="outlined" component="label" size="small" sx={{ mb: 1 }}>
                          Upload .crt/.pem
                          <input
                            type="file"
                            accept=".crt,.pem"
                            hidden
                            onChange={handleRootCAUpload}
                          />
                        </Button>
                        <TextField
                          fullWidth
                          multiline
                          rows={4}
                          value={jsonData?.root_ca}
                          placeholder="Root CA content"
                          onChange={(e) =>
                            setJsonData((prev) => ({ ...prev, root_ca: e.target.value }))
                          }
                        />
                      </>
                    ) : type === 'boolean' ? (
                      <ToggleButtonGroup
                        value={
                          jsonData?.[key] === true
                            ? 'true'
                            : jsonData?.[key] === false
                            ? 'false'
                            : ''
                        }
                        exclusive
                        onChange={(e, val) => {
                          if (val !== null) {
                            setJsonData((prev) => ({
                              ...prev,
                              [key]: val === 'true',
                            }));
                          }
                        }}
                        size="small"
                      >
                        <ToggleButton value="true">True</ToggleButton>
                        <ToggleButton value="false">False</ToggleButton>
                      </ToggleButtonGroup>
                    ) : (
                      <TextField
                        type={type === 'number' ? 'number' : 'text'}
                        fullWidth
                        value={jsonData?.[key] ?? ''}
                        onChange={(e) => {
                          const inputVal = e.target.value;
                          const val = type === 'number' ? Number(inputVal) : inputVal;
                          setJsonData((prev) => ({
                            ...prev,
                            [key]: val,
                          }));
                        }}
                      />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      ) : (
        <Box>
          <Button variant="contained" component="label" sx={{ mb: 2 }}>
            Upload JSON File
            <input type="file" accept=".json" hidden onChange={handleFileUpload} />
          </Button>

          <TextField
            label="JSON Preview"
            multiline
            rows={8}
            fullWidth
            value={jsonInput}
            onChange={handleJsonChange}
            error={Boolean(jsonError)}
            helperText={jsonError || ''}
          />
        </Box>
      )}

      {jsonData && configName && validateJsonSchema(jsonData) && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          sx={{ mt: 4, display: 'block', mx: 'auto' }}
        >
          Save Configuration
        </Button>
      )}

      {serverResponse.error ? (
        <Typography
          color="error"
          sx={{ mt: 3, textAlign: 'center', fontSize: '1.1rem', fontWeight: 'bold' }}
        >
          {serverResponse.error}
        </Typography>
      ) : (
        serverResponse.message && (
          <Typography
            color="success.main"
            sx={{ mt: 3, textAlign: 'center', fontSize: '1.1rem', fontWeight: 'bold' }}
          >
            {serverResponse.message}
          </Typography>
        )
      )}
    </Box>
  );
}

export default NewConfigPage;
